import {
    CounterpartyFieldReviewDto,
    getUserReviewedCounterpartyFields,
} from "@common/schemas/counterpartyFieldReview.schema";
import { CounterpartyReviewField } from "@common/types/counterpartyFieldReview";

export const isCounterpartyFieldReviewedByUser = (
    fieldReviews: CounterpartyFieldReviewDto[] | undefined,
    field: CounterpartyReviewField,
    userId: number | undefined,
) => getUserReviewedCounterpartyFields(fieldReviews, userId).has(field);

export const mergeCounterpartyFieldReviews = (
    existingReviews: CounterpartyFieldReviewDto[] | undefined,
    addedReviews: CounterpartyFieldReviewDto[],
) => [
    ...(existingReviews ?? []).filter(
        (existingReview) =>
            !addedReviews.some(
                (addedReview) =>
                    addedReview.field === existingReview.field &&
                    addedReview.userId === existingReview.userId,
            ),
    ),
    ...addedReviews,
];

export const removeCounterpartyFieldReview = (
    fieldReviews: CounterpartyFieldReviewDto[] | undefined,
    field: CounterpartyReviewField,
    userId: number | undefined,
) =>
    (fieldReviews ?? []).filter(
        (review) => !(review.userId === userId && review.field === field),
    );
